export default __webpack_public_path__ + "static/media/plugin-beta-step2.5fc4285e.gif";